import { HydrateAction } from "./types";
import { AppState } from "../index";

// NOTE: Application wide actions that may be used in multiple reducers
export const HYDRATE = "application/HYDRATE";
export const hydrate = (payload: AppState): HydrateAction => ({
  type: HYDRATE,
  payload
});
